
export default class Print {

	ready() {

		jQuery(document).on('click', '.print', function(e){

			window.print();

			e.preventDefault();

		});

    }
}